function alertAppend(type, message, domAppend) {
  // Define Bootstrap classes for different alert types
  const alertTypes = {
    success: 'alert-success',
    error: 'alert-danger',
    warning: 'alert-warning',
    info: 'alert-info'
  };

  // Create the alert HTML element
  const alertHtml = `
      <div class="alert ${alertTypes[type] || 'alert-info'} alert-dismissible fade mb-0 mt-4 show" role="alert">
          ${message}
          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>
  `;

  // Append the alert to the DOM, e.g., to a container with id "alert-container"
  $(domAppend).append(alertHtml);
}

window.alertAppend = alertAppend;
